import React from 'react';
import Card from '../../../../components/molecules/cards';

interface VendingMachine {
    clientId: number
    deviceId: string
    id: number
    location: string
    nickName: string
    removed: boolean
    type: 1 | 0
}

interface Props {
    vendingMachines : VendingMachine[] | undefined
}

function RenderVendingMachines(props: Props): React.ReactElement<Props> {
  const { vendingMachines } = props;
  if (!vendingMachines || vendingMachines.length === 0) {
    return (
      <div className="d-none">Vending Machines (0)</div>
    );
  }
  return (
    <div className="w-100">
      <div className="fz-14 ps-4 mb-2">{`Vending Machines (${vendingMachines.length})`}</div>
      <div className="w-100 d-flex flex-wrap gap-2">
        {vendingMachines.map((vendingMachine) => (
          <div key={vendingMachine.id}>
            <Card.Badge
              id={vendingMachine.id.toString()}
              label={vendingMachine.deviceId}
              iconType={vendingMachine.type === 0 ? 'soda' : 'snack'}
            />
          </div>
        ))}
      </div>
    </div>
  );
}

export default RenderVendingMachines;
